import Vue  from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

import * as types from "./types"
import * as api   from "./api/main"

export default new Vuex.Store({
  state: {
    api: {
      status: 'idle',
      errors: false,
    },
    order: false,
    payment: {
      authorization: false,
    },
    cart: {
      loaded: false,
      items: [],
      shipping: {
        address: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          address1: null,
          address2: null,
          city: null,
          state: null,
          zip: null,
        },
        methods: [],
        method: false,
      },
    },
    shop: {
      selectedColor: null,
      selectedProduct: null,
      products: [
        {
          id: 4,
          name: '4 Gun Mattress',
          short_name: '4 GUN',
          img: '/img/sizes/gun_size_4_GUN.svg',
          description: '28" x 48"'
        },
        {
          id: 6,
          name: '6 Gun Mattress',
          short_name: '6 GUN',
          img: '/img/sizes/gun_size_6_GUN.svg',
          description: '38" x 48"'
        },
        {
          id: 8,
          name: '8 Gun Mattress',
          short_name: '8 GUN',
          img: '/img/sizes/gun_size_8_GUN.svg',
          description: '48" x 48"'
        },
      ],
      colors: [
        {
          id: 1,
          name: 'Black',
          full_name: 'Black',
          img: '/img/colors/color_black.png',
          fabric: 'Solution Dyed Polyester'
        },
        {
          id: 2,
          name: 'Charcoal Grey',
          full_name: 'Charcoal Grey',
          img: '/img/colors/color_grey.png',
          fabric: 'Denier PVC Polyester'
        },
        {
          id: 3,
          name: 'Sand Beige',
          full_name: 'Sand Beige',
          img: '/img/colors/color_tan.png',
          fabric: 'Denier PVC Polyester'
        },
        {
          id: 4,
          name: 'Chocolate Brown',
          full_name: 'Chocolate Brown',
          img: '/img/colors/color_maroon.png',
          fabric: 'Denier PVC Polyester'
        },
        //{
        //    id: 5,
        //    name: 'WWII Autumn Camo',
        //    full_name: 'WWII Autumn Camo Print (limited edition)',
        //    img: '/img/colors/color_browncamo.png',
        //    fabric: 'Cordura Plus'
        //},
        {
          id: 6,
          name: 'Tan',
          full_name: 'Tan',
          img: '/img/colors/color_brown.png',
          fabric: 'Solution Dyed Polyester'
        },
        {
          id: 7,
          name: 'Olive Drab Green',
          full_name: 'Olive Drab Green Cotton Duck Canvas #8',
          img: '/img/colors/color_od_green.png',
          fabric: 'Cotton Duck'
        },
        {
          id: 8,
          name: 'Green Camo',
          full_name: 'Green Camo Print',
          img: '/img/colors/color_green_camo.png',
          fabric: 'Denier PVC Polyester'
        },
        {
          id: 9,
          name: 'Loden Green',
          full_name: 'Loden Green',
          img: '/img/colors/color_green.png',
          fabric: 'Denier PVC Polyester'
        },
        {
          id: 10,
          name: 'Bushlan® Green',
          full_name: 'Bushlan® Green',
          img: '/img/colors/bushlan_green.png',
          fabric: '1000 Denier Nylon'
        },
        {
          id: 11,
          name: 'Bushlan® Brown',
          full_name: 'Bushlan® Brown',
          img: '/img/colors/bushlan_brown.png',
          fabric: '1000 Denier Nylon'
        },
        {
          id: 12,
          name: 'Bushlan® Grey',
          full_name: 'Bushlan® Grey',
          img: '/img/colors/bushlan_grey.png',
          fabric: '1000 Denier Nylon'
        },
      ],
      fabrics: [
        {
          name: 'Solution Dyed Polyester',
          description: 'Solution Dyed Polyester 600 Denier (urethane water repellent coating)  - Excellent strength, durability, UV and mildew resistant. Easy to clean, abrasion resistant and environmentally friendly.'
                       +
                       '<br/><br/> 600 Denier Solution Dyed Polyester is Marine Grade Canvas designed for unforgivable and extreme conditions. This material is commonly used to manufacture boat covers and awnings due its water and mildew resistant qualities. This versatile fabric is useful for both in and outdoor use.'
                       +
                       '<br/><br/> Solution dyeing is a yarn coloration process in which pigment is added to the melted polymer before the polymer’s extrusion into the fiber. The color, is an inherent part of the yarn, lending itself to be particularly suited to demanding commercial environments. Features of 100% solution dyed products include:'
                       +
                       '<ul><li>Impervious to spot cleaning with bleach-based solutions and other harsh chemicals.</li><li>Colorfastness</li><li>Environmentally friendly and efficient, using little water or energy.</li><li>Precise color uniformity.</li></ul>'
                       + 'Solution dyed fabrics are one of the few fabrics that will hold their color in constant sun.'
        },
        {
          name: 'Cordura Plus',
          description: 'Cordura Plus is a textured nylon for a natural spun-like appearance, with excellent resistance to abrasion, rot and mildew. Quick drying and highly water-repellent, camouflage print.'
                       +
                       '<br/><br/>1000D (urethane coated) <strong><em>not solution dyed</em></strong> and <strong><em>not UV resistant</em></strong>'
        },
        {
          name: 'Cotton Duck',
          description: 'Cotton Duck #8 Fabric is a heavyweight, double-filled, untreated cotton material. Numbered Ducks are Double Filled, or Plied Yarn, materials which are created with a tighter weave construction and a smoother texture than single fill cotton ducks. This gives the material a stiffer hand, but makes them much hardier.'
                       +
                       '<br/>(usually #8 is 18 oz in weight)<br/><ul><li>100% Double Filled Cotton</li><li>High Mildew Resistance</li><li>Highly Water Resistant</li></ul>'
        },
        {
          name: 'Denier PVC Polyester',
          description: 'Our 600 X 300 Denier PVC Backed Polyester is a polyester fabric with a durable 0.55mm vinyl embossed backing.  Waterproof, easy to clean, soft feel of polyester with the strength and durability of PVC'
        },
        {
          name: '1000 Denier Nylon',
          description: 'Bushlan uses a PVC-backed 1000 Denier Nylon Fabric that is textured for a natural spun-like appearance, with excellent resistance to fading, abrasion, rot and mildew. Quick drying, and highly water repellent.'
        }
      ]
    }
  },
  getters: {
    products: state => {
      return state.shop.products.sort((a, b) => {
        return a.id - b.id
      })
    },
    reversedProducts: (state, getters) => {
      return getters.products.reverse()
    },
    colors: state => {
      return state.shop.colors.map(color => {
        return Object.assign({}, color, {
          fabric: state.shop.fabrics.find(fabric => fabric.name === color.fabric)
        })
      }).sort((a, b) => {
        return a.id - b.id
      })
    },
    selectedColor: state => state.shop.selectedColor,
    selectedProduct: state => state.shop.selectedProduct,
    cartLoaded: state => state.cart.loaded,
    cartItems: state => state.cart.items,
    cartSubTotal: state => {
      let total = 0;
      if (state.cart.items.length > 0) {
        for (let x = 0; x < state.cart.items.length; x++) {
          total += state.cart.items[x].price
        }
      }
      return total;
    },
    cartTax: (state, getters) => {
      return (getters.shippingFilledOut && state.cart.shipping.address.state == "TX"
        ? getters.cartSubTotal * 0.0825
        : 0) + getters.shipTotal * 0.0825;
    },
    shipTotal: state => {
      return state.cart.shipping.method !== false ? state.cart.shipping.method.amount : 0;
    },
    cartTotal: (state, getters) => {
      return getters.cartSubTotal + getters.cartTax + getters.shipTotal
    },
    shippingAddress: state => state.cart.shipping.address,
    shippingMethods: state => state.cart.shipping.methods,
    sortedShippingMethods: state => {
      let methods = [];
      for (let provider_name in state.cart.shipping.methods) {
        for (let method_name in state.cart.shipping.methods[provider_name]) {
          let method = state.cart.shipping.methods[provider_name][method_name];
          methods.push({
            provider: provider_name,
            name: method_name,
            amount: method.amount,
            estimate: method.estimate,
            token: method.token
          })
        }
      }

      return methods.sort((a, b) => {
        return a.amount - b.amount;
      }).sort((a, b) => {
        return a.estimate - b.estimate;
      })
    },
    shippingMethod: state => state.cart.shipping.method,
    shippingFilledOut: state => {
      return (
        state.cart.shipping.address.first_name !== null &&
        state.cart.shipping.address.last_name !== null &&
        state.cart.shipping.address.email !== null &&
        state.cart.shipping.address.address1 !== null &&
        state.cart.shipping.address.city !== null &&
        state.cart.shipping.address.state !== null &&
        state.cart.shipping.address.zip !== null
      );
    },
    order: state => state.order
  },
  mutations: {
    [types.SET_API_ERROR]: (state, error) => {
      state.api.errors = error
    },
    [types.SET_API_STATUS]: (state, status) => {
      state.api.status = status
    },
    [types.SET_COLOR]: (state, color) => {
      state.shop.selectedColor = color
    },
    [types.SET_PRODUCT]: (state, product) => {
      state.shop.selectedProduct = product
    },
    [types.FETCH_CART]: (state, cart) => {
      state.cart.items            = cart.items
      state.cart.shipping.address = cart.shipping.address
      state.cart.shipping.methods = cart.shipping.methods
      state.cart.shipping.method  = cart.shipping.method
      state.cart.loaded           = true
    },
    [types.ADD_TO_CART]: (state, items) => {
      state.cart.items            = items
      state.cart.shipping.methods = []
      state.cart.shipping.method  = false
      state.shop.selectedColor    = null
      state.shop.selectedProduct  = null
      state.payment.authorization = false
    },
    [types.REMOVE_FROM_CART]: (state, id) => {
      state.cart.items.splice(state.cart.items.indexOf(state.cart.items.find(item => item.id === id)), 1);
      state.cart.shipping.methods = []
      state.cart.shipping.method  = false
      state.payment.authorization = false
    },
    [types.SET_SHIPPING_ADDRESS]: (state, shipping) => {
      for (let key in shipping) {
        if (shipping.hasOwnProperty(key) && state.cart.shipping.address.hasOwnProperty(key)) {
          state.cart.shipping.address[key] = shipping[key]
        }
      }
      state.cart.shipping.methods = []
      state.cart.shipping.method  = false
      state.payment.authorization = false
    },
    [types.FETCH_SHIPPING_METHODS]: (state, methods) => {
      state.cart.shipping.methods = methods
    },
    [types.SET_SHIPPING_METHOD]: (state, method) => {
      state.cart.shipping.method  = method
      state.payment.authorization = false
    },
    [types.CLEAR_SHIPPING_METHOD]: (state) => {
      state.cart.shipping.method  = false
      state.payment.authorization = false
    },
    [types.FETCH_PAYMENT_AUTHORIZATION]: (state, status) => {
      state.payment.authorization = status
    },
    [types.PLACE_ORDER]: (state, order) => {
      state.cart.items            = []
      state.cart.shipping.address = {
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        address1: null,
        address2: null,
        city: null,
        state: null,
        zip: null,
      }
      state.cart.shipping.methods = []
      state.cart.shipping.method  = false
      state.order                 = order
    },
  },
  actions: {
    [types.SET_COLOR]: ({ commit, state, getters }, color) => {
      return Promise.resolve(commit(types.SET_COLOR, color));
    },
    [types.SET_PRODUCT]: ({ commit, state, getters }, product) => {
      return Promise.resolve(commit(types.SET_PRODUCT, product));
    },
    [types.FETCH_CART]: ({ commit, state, getters }) => {
      return new Promise((resolve, reject) => {
        api.fetchCart(commit).then(data => {
          commit(types.FETCH_CART, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.ADD_TO_CART]: ({ commit, state, getters }, payload) => {
      return new Promise((resolve, reject) => {
        api.addToCart(commit, payload).then(data => {
          commit(types.ADD_TO_CART, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.REMOVE_FROM_CART]: ({ commit, state, getters }, id) => {
      return new Promise((resolve, reject) => {
        api.removeFromCart(commit, id).then(data => {
          commit(types.REMOVE_FROM_CART, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.SET_SHIPPING_ADDRESS]: ({ commit, state, getters }, payload) => {
      return new Promise((resolve, reject) => {
        api.setShipping(commit, payload).then(data => {
          commit(types.SET_SHIPPING_ADDRESS, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.FETCH_SHIPPING_METHODS]: ({ commit, state, getters }) => {
      return new Promise((resolve, reject) => {
        api.fetchShippingMethods(commit).then(data => {
          commit(types.FETCH_SHIPPING_METHODS, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.SET_SHIPPING_METHOD]: ({ commit, state, getters }, token) => {
      return new Promise((resolve, reject) => {
        api.setShippingMethod(commit, token).then(data => {
          commit(types.SET_SHIPPING_METHOD, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.CLEAR_SHIPPING_METHOD]: ({ commit, state, getters }) => {
      return new Promise((resolve, reject) => {
        api.clearShippingMethod(commit).then(data => {
          commit(types.CLEAR_SHIPPING_METHOD, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.FETCH_PAYMENT_AUTHORIZATION]: ({ commit, state, getters }) => {
      return new Promise((resolve, reject) => {
        api.getAuthStatus(commit).then(data => {
          commit(types.FETCH_PAYMENT_AUTHORIZATION, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.SET_PAYMENT_AUTHORIZATION]: ({ commit, state, getters }, auth) => {
      return new Promise((resolve, reject) => {
        api.setAuthStatus(commit, auth).then(data => {
          commit(types.FETCH_PAYMENT_AUTHORIZATION, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    },
    [types.PLACE_ORDER]: ({ commit, state, getters }, auth) => {
      return new Promise((resolve, reject) => {
        api.placeOrder(commit, auth).then(data => {
          commit(types.PLACE_ORDER, data);
          resolve(data)
        }).catch(error => {
          reject(error)
        })
      })
    }
  },
})


// WEBPACK FOOTER //
// ./src/store/index.js